import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const divisionImporterSelectors = importerSelectors(
  'division.importer',
);

export default divisionImporterSelectors;
